<div class="d-flex justify-content-between align-items-center">
  <span *ngIf="showLabel" class="info-label">{{'customer.totalDebtWithCurrentAccountBalance' | translate}}</span>
  <h5>
    <span class="badge rounded" [ngClass]="{'bg-success':balance>0,'bg-danger':balance<0,'bg-info':balance==0}" triggers="mouseenter:mouseleave" placement="top" container="body"
      [ngbPopover]="tooltipContent">
      <i class="fas fa-info-circle"></i>
      <span *ngIf="balance>0">{{'payment.current-account-positive-status' | translate}}</span>
      <span *ngIf="balance<0">{{'payment.current-account-negative-status' | translate}}</span>
      {{ balance | abs | thousandSeparatorWithDecimals}}
    </span>
  </h5>
</div>

<ng-template #tooltipContent>
  <div>
    <div>
      <strong>{{'customer.totalDebt' | translate}}:</strong>
      <span [style.color]="totalDebt > 0 ? 'red' : ''">{{ totalDebt | thousandSeparatorWithDecimals }}</span>
    </div>
    <div>
      <strong>{{'customer.currentAccountBalance' | translate}}:</strong>
      <span [style.color]="currentAccountBalance > 0 ? 'green' : (currentAccountBalance < 0 ? 'red' : '')">{{ currentAccountBalance | thousandSeparatorWithDecimals }}</span>
    </div>
  </div>
</ng-template>